<div class="form-section-container" id="form-side-nav">
  <div class="form-sections-title">
    <span class="form-sections-title-text">Form Sections</span>
  </div>
  <ng-container *ngFor="let section of formSectionsInfo">
    <a [fragment]="section.key"
       class="form-section-name"
       [ngClass]="isSelectedSection(section.key) ? 'selected-form-section-name' : ''" (click)="changeSection(section.key)"
       skipLocationChange>
      <div class="form-section-name-content">
        <div>{{ section.value }}</div> 
        <div *ngIf="sectionHasError(section.value)">
          <mat-icon class="input-error">warning</mat-icon>
        </div>
      </div>
    </a>
  </ng-container>
</div>
